var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Recipe = (function (Recipe) {

        Recipe.Messages = (function (Messages) {

            Messages.GetModel = function (itemId, path, attributes, ingredientsAttributes) {
                var data = {
                    itemId: itemId,
                    path: path,
                    attributes: attributes,
                    ingredientsAttributes: ingredientsAttributes
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Recipe.Messages.GetModel', data);
            };
            Messages.GetModel.className = 'Vendd.Recipe.Messages.GetModel';

            Messages.GetModelSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.GetModelSuccess', response);
            };
            Messages.GetModelSuccess.className = 'Vendd.Product.Messages.GetModelSuccess';

            Messages.GetModelFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.GetModelFailure', response);
            };
            Messages.GetModelFailure.className = 'Vendd.Product.Messages.GetModelFailure';

            Messages.Changed = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Recipe.Messages.Changed', response);
            };
            Messages.Changed.className = 'Vendd.Recipe.Messages.Changed';

            Messages.Failed = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Recipe.Messages.Failed', response);
            };
            Messages.Failed.className = 'Vendd.Recipe.Messages.Failed';

            return Messages;

        })(Recipe.Messages || {});

        return Recipe;

    })(Vendd.Recipe || {});


    return Vendd;

})(Vendd || {});